import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComputerMouse, faGamepad, faCouch, faPerson, faHouse, faTemperatureEmpty, faVrCardboard } from '@fortawesome/free-solid-svg-icons';

export default function VrIcons({ vrFeature }) {
  if (vrFeature === 'valve_index') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" preserveAspectRatio="xMinYMin meet" viewBox="0 0 440 220.24" role="img" aria-label="Valve Index">
        <g fill="#fff">
          <path d="M220,123.64V219c-38.31,2.45-98.4-25.81-109.49-95.71v96.44c-39.1-1.36-70.3-17-91.29-49.4C-5.69,131.92-6.4,91.57,17.23,52.44,37.93,18.16,69.85,1.51,110.39,0V97.58c9.42-67,67.26-99.08,109.55-96.91V96.89C229.89,33.14,284.05-4.55,339.85.62,396.39,5.85,439.52,52.69,440,108.36c.48,56.37-41.73,104.62-96,111.1C288.25,226.1,230.44,189.83,220,123.64Z" />
        </g>
      </svg>
    );
  }

  if (vrFeature === 'htc_vive') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" preserveAspectRatio="xMinYMin meet" viewBox="0 0 400 353.28" role="img" aria-label="HTC Vive">
        <g fill="#fff">
          <path d="M350.72,353.28H50.24A4.37,4.37,0,0,0,48,353a23.34,23.34,0,0,1-6.12-1.77,26,26,0,0,1-12.4-11.11Q16.85,318.23,4.21,296.37A26.66,26.66,0,0,1,.59,286.05,1.52,1.52,0,0,0,0,284.8v-4.16a1.67,1.67,0,0,0,.58-1.27,26.54,26.54,0,0,1,3.54-10.19L54,182.77q43.27-74.91,86.54-149.84,5.67-9.83,11.36-19.66A26.17,26.17,0,0,1,171,.34c.41-.06.86,0,1.19-.34h55.36a4.08,4.08,0,0,0,2.23.34c.78.15,1.57.28,2.35.47a25.84,25.84,0,0,1,16.75,12.63q37.61,65.07,75.2,130.17,32.49,56.22,65,112.44c2.58,4.48,5.19,8.95,7.75,13.44a21.47,21.47,0,0,1,3,8.2c0,.14.16.26.24.39v9.28a.65.65,0,0,0-.28.54,10.66,10.66,0,0,1-.63,2.79,29.23,29.23,0,0,1-2.73,5.93q-8.73,15.06-17.42,30.13c-2.67,4.61-5.26,9.26-8,13.81A25.48,25.48,0,0,1,352.66,353,2.92,2.92,0,0,0,350.72,353.28Zm-150.87-48c5.74.05,14.05-.3,20.61-.86q9.09-.78,18.08-2.24a235.82,235.82,0,0,0,32.32-7.69c21.83-6.81,36.44-26.31,37.74-47.45a51.57,51.57,0,0,0-.65-12.1c-.84-4.78-2-9.49-3.27-14.17q-17.87-65.82-68-112.11a52.61,52.61,0,0,0-31.57-14,51.87,51.87,0,0,0-15.43.83,53.41,53.41,0,0,0-26,13.36A234.37,234.37,0,0,0,93.22,232.38a51.82,51.82,0,0,0,.41,24.23,53.83,53.83,0,0,0,35.87,37.77,232.29,232.29,0,0,0,52.62,10.19C188.12,305,194.14,305.3,199.85,305.26Z" />
        </g>
      </svg>
    );
  }

  if (vrFeature === 'oculus_meta_quest' || vrFeature === 'oculus_meta_quest_two' || vrFeature === 'oculus_meta_quest_three') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" preserveAspectRatio="xMinYMin meet" viewBox="0 0 300 184.71" role="img" aria-label="Meta Quest">
        <g fill="#fff">
          <path d="M262.6,35.1C247.2,12.2,227.2,0,206.1,0c-12.5,0-25,5.6-36.6,15.7c-7.8,6.8-15.1,15.4-21.8,24.5c-8.3-10.5-16-18.5-23.5-24.6C110.1,4,96.5,0,82.9,0C59.3,0,38.7,15.3,24.5,37.3C8.4,62,0,94.1,0,124.9c0,16.9,3.3,31.8,10.1,43.1h0l0,0c8.3,13.9,21.8,23.1,43,23.1c17.9,0,31.5-8,47.5-29.3c9.1-12.1,13.7-19.5,31.9-51.8l9.1-16.1c0.8-1.3,1.5-2.6,2.2-3.9c0.7,1.2,1.5,2.4,2.2,3.6l25.8,43.1c8.7,14.5,19.9,30.6,29.6,39.7c12.5,11.8,23.9,14.6,36.7,14.6h0l0,0c2.6,0,5-0.2,7.3-0.5c8.1-1.1,14.7-4,19.97.9c1.5-1.1,2.9-2.3,4.2-3.5c1.3-1.2,2.5-2.5,3.5-3.8c1.6-2,3-4,4.2-6c6.5-11.2,10.3-25.5,10.3-44.9C287.6,91.8,279.4,60.2,262.6,35.1z M117,86.2c-9.1,13.9-22.5,36.2-34,52C68.7,158,61.3,160,53.2,160c-6.3,0-12.4-2.8-16.6-9.5c-3.1-5.1-5.6-13.5-5.6-24.5c0-26.6,7.6-54.3,19.9-73c1.1-1.6,2.2-3.2,3.3-4.7s2.3-2.9,3.5-4.2c1.2-1.3,2.4-2.6,3.7-3.7c0.6-0.6,1.3-1.1,1.9-1.6c1.9-1.6,3.9-2.9,5.9-4c4.1-2.2,8.4-3.4,13-3.4c15.2,0,24.7,9.5,32,17.3c3.7,3.9,8.8,10.4,14.8,18.9L117,86.2z M258.6,141.5c2.5,10.8-8.4,18.5-20.5,18.5c-6.9,0-12.3-2.8-19.9-12c-5.9-7.2-16.1-22.5-33.9-52.2l-7.4-12.3c-5.3-8.8-10.3-16.7-15.1-23.8c0.9-1.3,1.7-2.6,2.5-3.9c13.4-20,25.4-31.2,40.2-31.2c13.7,0,26.2,9.1,35.8,23.9c13.6,21,19.7,50.3,19.7,76.7C260.2,131,259.7,136.6,258.6,141.5z" />
        </g>
      </svg>
    );
  }

  if (vrFeature === 'oculus_rift') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" preserveAspectRatio="xMinYMin meet" viewBox="0 0 306 184.71" role="img" aria-label="Oculus Rift">
        <g fill="#fff">
          <path d="M271.67,20.93A92.8,92.8,0,0,0,235.19,3.08,118.45,118.45,0,0,0,212,.15C206.1,0,200.25,0,194.4,0H111.59C105.75,0,99.9,0,94.05.15A118.64,118.64,0,0,0,70.8,3.08,92.93,92.93,0,0,0,34.32,20.93a91.47,91.47,0,0,0,0,142.84A93,93,0,0,0,70.8,181.63a117.87,117.87,0,0,0,23.25,2.92c5.85.16,11.7.16,17.54.16H194.4c5.85,0,11.7,0,17.55-.16a117.68,117.68,0,0,0,23.24-2.92,92.82,92.82,0,0,0,36.48-17.86,91.46,91.46,0,0,0,0-142.84Zm-40.32,96.21a33.21,33.21,0,0,1-13.55,5.23c-4.92.77-9.7.61-14.62.61H102.82c-4.93,0-9.7.16-14.62-.61a33.21,33.21,0,0,1-13.55-5.23A30.31,30.31,0,0,1,61.57,92.35,29.91,29.91,0,0,1,74.65,67.57,33.21,33.21,0,0,1,88.2,62.34c4.92-.77,9.7-.62,14.62-.62H203.18c4.92,0,9.7-.15,14.62.62a33.21,33.21,0,0,1,13.55,5.23,30.33,30.33,0,0,1,13.08,24.78A29.93,29.93,0,0,1,231.35,117.14Z" />
        </g>
      </svg>
    );
  }

  if (vrFeature === 'windows_mixed_reality') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" preserveAspectRatio="xMinYMin meet" viewBox="0 0 300 280.79" role="img" aria-label="Windows Mixed Reality">
        <g fill="#fff">
          <path d="M150.55.05C188,.51,225.36,1.42,262,10.29a104,104,0,0,1,18.33,6.08C293.25,22.21,300.6,32,299.9,46.82c-.92,19.31,2.29,38.86-3.29,57.92-12.29,42-50.89,68.5-98.92,63.36-6.72-.72-12.15-4.22-17.33-8.12-3.82-2.88-7.39-6.09-11-9.2-14.47-12.4-23.44-12.47-37.8-.24-2.14,1.82-4.37,3.56-6.39,5.51-10.39,10-22.71,13.3-37.05,12.64-41.73-1.89-74.61-26.91-84.61-66C-1.89,81.65.25,60.05,1.41,38.8c.64-11.85,10.06-19,20.8-23.4,17.07-7,35.19-9.62,53.31-11.61A612.31,612.31,0,0,1,150.55.05Zm3.69,18.55c-28.11.2-52,1.38-75.78,3.74-16.18,1.6-32.3,4-47.67,9.86-7.88,3-12.33,7.71-11.64,17.06.78,10.35.23,20.81.17,31.22A67.18,67.18,0,0,0,28,114.34c10.21,18.17,25.74,29.49,46,34,18,4,34.61,1.94,47.35-13.46,1.73-2.1,4.41-3.45,6.75-5,9.83-6.52,20.49-9.35,32-5.94,9.63,2.85,17.29,9.13,24.76,15.63,4.61,4,8.84,9.08,15.38,9.8,43.16,4.75,73.19-21.74,79.63-55.15,2.63-13.71,1.07-27.49,1.34-41.24.31-15.94-1.14-17.59-16.6-22.53-2.13-.68-4.3-1.26-6.47-1.8C222.59,19.85,186.26,20,154.24,18.6Z" transform="translate(0)" />
          <path d="M148.1,280.79c-32.53-1.27-59-17.52-78.88-45.56-3.79-5.36-4.82-11,1.61-15.38s10.53-.19,14,4.66c13.6,19,30.6,32.77,54.44,36.34,28.46,4.26,51.05-6.47,69.53-27.44,3-3.36,5.37-7.22,8.2-10.7,3.61-4.43,7.93-6.46,13.18-2.69,5.08,3.66,5,8.55,2.24,13.42-4.53,7.87-10.65,14.5-17.3,20.61C196.86,270.83,175.51,280.22,148.1,280.79Z" transform="translate(0)" />
          <path d="M149.81,55.93c-2.81,0-5.62.06-8.42,0-5.33-.18-8.42-3.08-8.77-8.29-.37-5.56,2.56-9.43,8-10a109.07,109.07,0,0,1,18.52-.08c5.4.38,8.9,3.66,8.76,9.35-.14,6-3.48,9.2-9.71,9.05C155.43,55.88,152.62,55.94,149.81,55.93Z" transform="translate(0)" />
        </g>
      </svg>
    );
  }

  if (vrFeature === 'seated') {
    return (
      <FontAwesomeIcon icon={faCouch} />
    );
  }

  if (vrFeature === 'standing') {
    return (
      <FontAwesomeIcon icon={faPerson} />
    );
  }

  if (vrFeature === 'room_scale') {
    return (
      <FontAwesomeIcon icon={faHouse} />
    );
  }

  if (vrFeature === 'tracked_motion_controllers') {
    return (
      <FontAwesomeIcon icon={faTemperatureEmpty} />
    );
  }

  if (vrFeature === 'gamepad') {
    return (
      <FontAwesomeIcon icon={faGamepad} />
    );
  }

  if (vrFeature === 'keyboard_mouse') {
    return (
      <FontAwesomeIcon icon={faComputerMouse} />
    );
  }

  if (vrFeature === 'vr_required') {
    return (
      <FontAwesomeIcon icon={faVrCardboard} />
    );
  }
  return false;
}

VrIcons.propTypes = {
  vrFeature: PropTypes.string,
};

VrIcons.defaultProps = {
  vrFeature: '',
};
